import React from 'react';
import App from '../../../App/App';
// Override some styles
import './App.scss';

const AppHengel = (props) => (
  <App {...props} containerExtraClassName="hengel-eu" />
);
export default AppHengel;
